import React, { useEffect, useState } from 'react';
import './ToastNotification.scss';

interface ToastNotificationProps {
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
  onClose: () => void;
}

const ToastNotification: React.FC<ToastNotificationProps> = ({
  message,
  type,
  duration = 5000,
  onClose
}) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleTransitionEnd = () => {
    if (!isVisible) {
      onClose();
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      // Don't call onClose here - let the transition end event handle it
    }, duration);

    return () => clearTimeout(timer);
  }, [duration]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      case 'warning':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      default:
        return '📢';
    }
  };

  return (
    <div 
      className={`toast-notification ${type} ${isVisible ? 'visible' : 'hidden'}`}
      onTransitionEnd={handleTransitionEnd}
    >
      <div className="toast-content">
        <div className="toast-icon">{getIcon()}</div>
        <div className="toast-message">{message}</div>
        <button className="toast-close" onClick={() => {
          setIsVisible(false);
          // Don't call onClose here - let the transition end event handle it
        }}>
          ×
        </button>
      </div>
    </div>
  );
};

export default ToastNotification;

